import { CommonEnums } from '../../common.enums';

export class DataMaskingInst {
    dataMaskingInstId: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxMp_Id: number;
    persistFlg: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    attr_Tab_Valid_Cd: string;
    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.dataMaskingInstId = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.persistFlg = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;

    }


    static parse(dataMaskingInstTmp: DataMaskingInst): DataMaskingInst {
        let dataMaskingInst = new DataMaskingInst();
        dataMaskingInstTmp.copyFrom(dataMaskingInstTmp as DataMaskingInst);
        return dataMaskingInst;
    }



    copy(): DataMaskingInst {
        let dataMaskingInstTmp: DataMaskingInst = new DataMaskingInst();

        dataMaskingInstTmp.dataMaskingInstId = this.dataMaskingInstId;

        dataMaskingInstTmp.nm = this.nm;
        dataMaskingInstTmp.description = this.description;
        dataMaskingInstTmp.ver = this.ver;
        dataMaskingInstTmp.valid_Cd = this.valid_Cd;
        dataMaskingInstTmp.dxMp_Id = this.dxMp_Id;
        dataMaskingInstTmp.persistFlg = this.persistFlg;
        dataMaskingInstTmp.updateBy = this.updateBy;
        dataMaskingInstTmp.lastUpdateBy = this.lastUpdateBy;
        dataMaskingInstTmp.updateDt = this.updateDt;
        dataMaskingInstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;

        return dataMaskingInstTmp;
    }
    
    copyFrom(dataMaskingInstTmp: DataMaskingInst): void {
        this.dataMaskingInstId = dataMaskingInstTmp.dataMaskingInstId;
        this.nm = dataMaskingInstTmp.nm;
        this.description = dataMaskingInstTmp.description;
        this.ver = dataMaskingInstTmp.ver;
        this.valid_Cd = dataMaskingInstTmp.valid_Cd;
        this.dxMp_Id = dataMaskingInstTmp.dxMp_Id;
        this.persistFlg = dataMaskingInstTmp.persistFlg;
        this.updateBy = dataMaskingInstTmp.updateBy;
        this.lastUpdateBy = dataMaskingInstTmp.lastUpdateBy;
        this.updateDt = dataMaskingInstTmp.updateDt;
        this.attr_Tab_Valid_Cd = dataMaskingInstTmp.attr_Tab_Valid_Cd;

    }

    compare(dataMaskingInstTmp: DataMaskingInst): string {
        let dataMaskingInstString: string = this.toString();
        let dataMaskingInstTmpString: string = dataMaskingInstTmp.toString();

        if (dataMaskingInstString != dataMaskingInstTmpString) {
            return dataMaskingInstString + ', ' + dataMaskingInstTmpString;
        }

        return '';
    }


    toString(): string {
        let str: string = "dataMaskingInst [dataMaskingInstId=" + this.dataMaskingInstId + ",nm=" + this.nm +
            ",description= " + this.description + ",ver= " + this.ver + ",valid_Cd=" + this.valid_Cd +

            ",dxMp_Id=" + this.dxMp_Id + ",persistFlg=" + this.persistFlg + ",updateBy=" + this.updateBy +
            ",lastUpdateBy=" + this.lastUpdateBy + ",updateDt=" + this.updateDt +
            ",attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd;

        return str;

    }




}


